module.exports = __webpack_public_path__ + "static/img/topbanner-08.d1df29b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/slides_banner/topbanner-08.jpg
// module id = uZXP
// module chunks = 0